var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"one-sidebar-header border-bottom border-top"},[_c('b-col',{staticClass:"py-3 d-flex justify-content-between align-items-center"},[_c('h4',{staticClass:"one-sidebar-header__title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }